module.exports = __webpack_public_path__ + "media/src/components/PremiumPricing/img/tick-cea57528a01fbc1d666ead999a9e0dc9.png";